import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./CreateCampaignTemplate.css";
import "./nameCampaign.css";
import { previewDevices, tabContent } from "./GoogleAutomationConstants";
import img from "../../assets/icons/leadTemplate.png";
import Select, { components } from "react-select";

const validationSchema = Yup.object({
  CampaignName: Yup.string()
    .trim()
    .min(3, "Campaign name must be at least 3 characters")
    .max(50, "Campaign name must be at most 50 characters")
    .required("Campaign name is required"),
});
const NameCampaign = ({
  setIsFormOneValid,
  setFormOneValue,
  formOneValue,
  buyingType,
  reactSelectStyles,
}) => {
  const [budgetType, setBudgetType] = useState("Auction");
  const [activeTab, setActiveTab] = useState("Awareness");
  const [previousTab, setPreviousTab] = useState("Leads");
  const [animationDirection, setAnimationDirection] = useState("slideIn");

  useEffect(() => {
    if (animationDirection === "slideOut") {
      const timeout = setTimeout(() => setAnimationDirection("slideIn"), 500);
      return () => clearTimeout(timeout);
    }
  }, [animationDirection]);

  const handleTabChange = (tab) => {
    if (tab !== activeTab) {
      setPreviousTab(activeTab);
      setActiveTab(tab);
      setAnimationDirection("slideOut");
    }
  };

  return (
    <div className=" h-[90vh] overflow-scroll pt-5 pb-32">
      <Formik
        initialValues={{
          CampaignName: formOneValue.CampaignName || "",
          buyingType: formOneValue.buyingType || budgetType,
          objective: formOneValue.objective || activeTab,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log("Form submitted with values:", values);
        }}
      >
        {({ errors, touched, isValid, dirty, values, setFieldValue }) => {
          if (dirty) {
            setIsFormOneValid(isValid && dirty);
            setFormOneValue(values);
          }

          return (
            <Form>
              <div className="create-form-item">
                <div style={{ fontWeight: "bold" }} className="f-14">
                  Name Your Campaign
                </div>
                <div className="name-input-container">
                  {/* <input type="text" placeholder="eg Adglobal360 Festive" /> */}
                  <Field
                    type="text"
                    name="CampaignName"
                    placeholder="eg Adglobal360 Festive"
                    className={
                      errors.CampaignName && touched.CampaignName
                        ? "error-input"
                        : ""
                    }
                  />
                  <ErrorMessage
                    name="CampaignName"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
              <div className="create-form-item">
                <div style={{ fontWeight: "bold" }} className="f-14">
                  Buying Type
                </div>
                <div className="toggle-type-buttons">
                  {buyingType.map((type) => (
                    <button
                      key={type}
                      className={`toggle-button f-14 ${
                        budgetType === type ? "active" : ""
                      }`}
                      onClick={() => {
                        setBudgetType(type);
                        setFieldValue("buyingType", type);
                      }}
                    >
                      {type}
                    </button>
                  ))}
                </div>
              </div>
              <div
                className="create-form-item"
                style={{
                  flexDirection: "column",
                  alignItems: "normal",
                  gap: "0px",
                  overflow: "hidden",
                }}
              >
                <div style={{ fontWeight: "bold" }} className="f-14">
                  Choose Campaign Objective
                </div>
                <div className="tabs-container">
                  <div className="tabs">
                    {Object.keys(tabContent).map((tab) => (
                      <div
                        key={tab}
                        className={`tab f-12 ${
                          activeTab === tab ? "active" : ""
                        }`}
                        onClick={() => {
                          handleTabChange(tab);
                          setFieldValue("objective", tab);
                        }}
                      >
                        {tab}
                      </div>
                    ))}
                  </div>
                  <div className={`tab-camp-details ${animationDirection}`}>
                    <img src={img} />
                    <div>
                      <h2 className="f-18">{tabContent[activeTab]?.title}</h2>
                      <p className="f-14">
                        {tabContent[activeTab]?.description}
                      </p>
                      <div className="good-for">
                        {tabContent[activeTab]?.goodFor?.map((item, index) => (
                          <span key={index} className="good-for-item f-12">
                            {item}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default NameCampaign;
